import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';
import AddedValueServiceCMSModel from '@/visa-application/models/AddedValueServiceCMSModel';

export interface ApplicationCenterOpeningHoursModel {
  opening_hours_service: string;
  opening_hours_duration: string;
}

export interface ApplicationCenterClosedDaysModel {
  closed_days_date: string;
  closed_days_reason: string;
}

export interface ApplicationCenterOpeningDaysModel {
  opening_days_duration: string;
  opening_days_service: string;
}

export default class ApplicationCenterCMSModel implements CMSModel {
  code = '';
  name = '';
  name_translation = '';
  background: FileCMSModel = undefined;
  address_name = '';
  address = '';
  address_google_map = '';
  opening_hours: ApplicationCenterOpeningHoursModel[] = [];
  opening_days: ApplicationCenterOpeningDaysModel[] = [];
  closed_days: ApplicationCenterClosedDaysModel[] = [];
  holiday_notice = '';
  news = '';
  news_background_color: string;
  special_news?: string;
  special_needs?: boolean;
  calendar_limit?: number;
  open_login: boolean;
  open_register: boolean;
  opening_hours_avs: AddedValueServiceCMSModel = new AddedValueServiceCMSModel();
  passback_avs_title = '';
  afp_release_duration = 2;
  floating_prompt = '';
  visa_application_assistance_link = '';
  visa_application_assistance_title = '';
  visa_application_assistance_button = '';
  temporary_closed = false;
  website_footer_logo: FileCMSModel = undefined;
  website_header_logo: FileCMSModel = undefined;
  hide_inquiry_form = false;

  map(obj: any): void {
    this.code = _.get(obj, 'code', '');
    this.name = _.get(obj, 'name', '');
    this.name_translation = _.get(obj, 'translation[0].name_translation', '');
    this.background = _.get(obj, 'background', undefined);
    this.address_name = _.get(obj, 'translation[0].address_name', '');
    this.address = _.get(obj, 'translation[0].address', '');
    this.address_google_map = _.get(obj, 'translation[0].address_google_map', '');
    this.opening_hours = _.get(obj, 'translation[0].opening_hours', []);
    this.opening_days = _.get(obj, 'translation[0].opening_days', []);
    this.closed_days = _.get(obj, 'translation[0].closed_days', []);
    this.holiday_notice = _.get(obj, 'translation[0].holiday_notice', '');
    this.news = _.get(obj, 'translation[0].news', '');
    this.news_background_color = _.get(obj, 'translation[0].news_background_color', '');
    this.special_news = _.get(obj, 'translation[0].special_news', '');
    this.special_needs = _.get(obj, 'special_needs', false);
    this.calendar_limit = _.get(obj, 'calendar_limit', '');
    this.open_login = _.get(obj, 'open_login', false);
    this.open_register = _.get(obj, 'open_register', false);
    this.opening_hours_avs.map(_.get(obj, 'opening_hours_avs', {}));
    this.passback_avs_title = _.get(obj, 'translation[0].passback_avs_title', 'Undefined');
    this.afp_release_duration = _.get(obj, 'afp_release_duration', 2);
    this.floating_prompt = _.get(obj, 'translation[0].floating_prompt', '');
    this.visa_application_assistance_link = _.get(obj, 'visa_application_assistance_link', '');
    this.visa_application_assistance_title = _.get(obj, 'translation[0].visa_application_assistance_title', '');
    this.visa_application_assistance_button = _.get(obj, 'translation[0].visa_application_assistance_button', '');
    this.temporary_closed = _.get(obj, 'temporary_closed', '');
    this.website_footer_logo = _.get(obj, 'website_footer_logo', undefined);
    this.website_header_logo = _.get(obj, 'website_header_logo', undefined);
    this.hide_inquiry_form = _.get(obj, 'hide_inquiry_form', false);
  }
}
